import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M15.021 8v3.75a3.179 3.179 0 0 1-3.32 3h-6.86a3.179 3.179 0 0 1-3.32-3V8a.75.75 0 0 1 1.5 0v3.75a1.693 1.693 0 0 0 1.82 1.5H11.7a1.693 1.693 0 0 0 1.82-1.5V8a.75.75 0 1 1 1.5 0ZM4.451 6.3a.742.742 0 0 0 .53-.22l2.27-2.27V10a.75.75 0 0 0 1.5 0V3.812l2.27 2.27a.75.75 0 0 0 1.06-1.06l-3.55-3.55a.748.748 0 0 0-1.06 0l-3.55 3.55a.737.737 0 0 0 0 1.06.725.725 0 0 0 .53.218Z';
const draw24px = 'M16.08,8.09a.75.75,0,0,1-1.06,0L12.75,5.81v9.51a.75.75,0,0,1-1.5,0V5.81L9,8.09a.75.75,0,0,1-1.06,0A.74.74,0,0,1,7.92,7l3.55-3.56a.78.78,0,0,1,.24-.16.73.73,0,0,1,.58,0,.78.78,0,0,1,.24.16L16.08,7A.75.75,0,0,1,16.08,8.09ZM19.75,16V11a.75.75,0,0,0-1.5,0v5A2.25,2.25,0,0,1,16,18.25H8A2.25,2.25,0,0,1,5.75,16V11a.75.75,0,0,0-1.5,0v5A3.75,3.75,0,0,0,8,19.75h8A3.75,3.75,0,0,0,19.75,16Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const UploadIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'upload'));
UploadIcon.displayName = 'UploadIcon';
UploadIcon.propTypes = Icon.propTypes;
UploadIcon.renderIcon = props => /*#__PURE__*/React.createElement(UploadIcon, props);
export default UploadIcon;
//# sourceMappingURL=UploadIcon.js.map